import { useQuery } from "@tanstack/react-query";
import { fetchRevenueCatOffering } from "@remotes/fetchRevenueCatOffering";

export function useRevenueCatOffering() {
  return useQuery({
    queryKey: ["revenueCatOffering"],
    queryFn: () => fetchRevenueCatOffering(),
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    refetchOnReconnect: false,
    staleTime: 5 * 60 * 1000, // Consider data stale after 5 minutes
    gcTime: 10 * 60 * 1000, // Keep in cache for 10 minutes
    retry: 2,
  });
} 